import script from "./ClinicalSetupDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ClinicalSetupDialog.vue?vue&type=script&setup=true&lang=js"

import "./ClinicalSetupDialog.vue?vue&type=style&index=0&id=1b13b38a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b13b38a"]])

export default __exports__